import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container'

import logo from '../../images/Weblogo.png'

const useStyles = makeStyles((theme) => ({
  logo: {
      maxWidth: 220
  },
  dashboardBtn: {
    maxWidth: 200
  },
  root: {
    justifyContent: 'space-between',
    alignItems: 'center',
    
  },
  links: {
    color: '#fff',
    padding: '0px 12px',
    fontWeight: 700,
    textTransform: 'uppercase',
    '&:hover': {
      color: "#f4f4f4",
      TextDecoder: 'none'
   },
  }
}));

const Menu = (props) => {
  const classes = useStyles();
  
  return (
    <div className={classes.root + " py-4 px-3 d-sm-flex"}>
      <div className="text-center">
        <Typography variant="h6" noWrap className="pl-2 text-light">
          <Link to="/" className={classes.links}>
            <img src={logo} alt="logo" className={classes.logo + " img-fluid"} />
          </Link>
        </Typography>
      </div>
      <div className="text-center text-sm-right mt-4 mt-sm-0">
        <a href="/locker" className={classes.links + " text-light"}>
          LOCKER
        </a>
        <a href="https://www.dextools.io/app/fantom/pair-explorer/0xef656b9eb5a039e46d3a68a9a8614f1a40b0d77c" target="_blank" className={classes.links + " text-light"}>
          CHART
        </a>
        <a href="https://spookyswap.finance/swap?outputCurrency=0xef656b9eb5a039e46d3a68a9a8614f1a40b0d77c" target="_blank" className={classes.links + " text-light"}>
          BUY
        </a>
        {/* <a href="#" onClick={props.callFunc} className={classes.links} style={{BORDER: '1px solid #fea73e', padding: '10px 10px', backgroundColor: '#fea73e'}}>
        

          <span className={props.connectedmsg}>CONNECTED</span>
          <span className={props.disconnectedmsg}>CONNECT WALLET</span>
          
        </a> */}
        {/* <a href="#" target="_blank" onClick={props.callFunc} className={classes.links}>Contract</a> */}
        <br className="d-md-none" />
        <br className="d-md-none" />
        <label className="QMF---inputLabel mt-4 mt-sm-0" for="#inputQMF">
          <AssignmentOutlinedIcon />
          <input 
            type="text" 
            id="inputQMF" 
            placeholder="Paste your address here...." 
            className="QMF---input" 
            onChange={props.callFunc}
          />
          <p className={props.errorMsg}>{props.useError} Invalid wallet address.</p>
        </label>
      </div>
    </div>
  );
}


export default Menu;
